if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        // Verifica se l'input variantId esiste prima di accedervi
        if (this.variantIdInput) {
          this.variantIdInput.disabled = false;
        }
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        // Rimuoviamo l'assegnazione qui perché l'attributo viene aggiunto dinamicamente
        // this.upsellVariantId = this.dataset.upsellVariantId;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
      
        setTimeout(async () => {
          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      
          this.handleErrorMessage();
      
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading__spinner').classList.remove('hidden');
      
          try {
            // Ottieni lo stato corrente del carrello
            const cartState = await this.getCartState();
            
            // Ottieni l'ID dell'upsell dinamicamente al momento del submit
            const upsellVariantId = this.getUpsellVariantId();
            console.log(upsellVariantId);
            
            // Se il carrello è vuoto e c'è un upsell, aggiungilo prima
            if (cartState.item_count === 0 && upsellVariantId) {
              await this.addUpsellProduct(upsellVariantId);
            }
            
            // Aggiungi il prodotto principale
            await this.addMainProduct();
            
          } catch (error) {
            console.error('Errore durante l\'aggiunta al carrello:', error);
            this.handleErrorMessage('Si è verificato un errore durante l\'aggiunta al carrello.');
          } finally {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }
            this.querySelector('.loading__spinner').classList.add('hidden');
          }
        }, 100);
      }

      async getCartState() {
        const response = await fetch(`${routes.cart_url}.js`);
        return await response.json();
      }

      async addUpsellProduct(upsellVariantId) {
        try {
          const config = this.getUpsellProductConfig(upsellVariantId);
          const response = await fetch(`${routes.cart_add_url}`, config);
          const result = await response.json();
          
          if (result.status) {
            console.warn('Errore aggiunta prodotto upsell:', result.description);
          } else {
            console.log('Prodotto upsell aggiunto con successo');
          }
          
          return result;
        } catch (error) {
          console.error('Errore durante l\'aggiunta del prodotto upsell:', error);
          throw error;
        }
      }

      async addMainProduct() {
        try {
          const config = this.getMainProductConfig();
          const response = await fetch(`${routes.cart_add_url}`, config);
          const result = await response.json();
          
          if (result.status) {
            // Gestione errori
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: this.getMainProductVariantId(),
              errors: result.errors || result.description,
              message: result.message,
            });
            
            this.handleErrorMessage(result.description);
            
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
            this.error = true;
            return;
            
          } else if (!this.cart) {
            // Se non c'è cart drawer/notification, reindirizza al carrello
            window.location = window.routes.cart_url;
            return;
          }

          // Successo - aggiorna l'interfaccia del carrello
          console.log('Prodotto principale aggiunto con successo');
          
          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: this.getMainProductVariantId(),
              cartData: result,
            });
          }
          
          this.error = false;
          
          // Gestisci modal quick-add se presente
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(result);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(result);
          }
          
        } catch (error) {
          console.error('Errore durante l\'aggiunta del prodotto principale:', error);
          this.handleErrorMessage('Si è verificato un errore durante l\'aggiunta al carrello.');
          throw error;
        }
      }


      // async addMainProduct() {
      //   try {
      //     const form = this.querySelector('form[data-type="add-to-cart-form"]');
      //     const formData = new FormData(form);
      //     const xhr = new XMLHttpRequest();
      //     const buttonText = this.submitButton.querySelector('.icona_testo_atc');
      //     const spinner = this.querySelector('.loading__spinner');

      //     // Mostra percentuale nel testo
      //     buttonText.textContent = 'Caricamento 0%';
      //     // spinner.classList.remove('hidden');

      //     const responsePromise = new Promise((resolve, reject) => {
      //       xhr.upload.onprogress = (e) => {
      //         if (e.lengthComputable) {
      //           const percent = Math.round((e.loaded / e.total) * 100);
      //           buttonText.textContent = `Caricamento ${percent}%`;
      //           // Se vuoi animare una barra, puoi usare:
      //           // this.submitButton.style.setProperty('--progress', percent + '%');
      //         }
      //       };

      //       xhr.onload = () => {
      //         if (xhr.status >= 200 && xhr.status < 300) {
      //           try {
      //             // console.log('Risposta XHR:', xhr.responseText);
      //             const result = JSON.parse(xhr.responseText);
      //             resolve(result);
      //           } catch (err) {
      //             console.error('Errore parsing JSON:', xhr.responseText);
      //             reject(err);
      //           }
      //         } else {
      //           reject(xhr.statusText);
      //         }
      //       };

      //       xhr.onerror = () => reject('Errore di rete');

      //       // xhr.open('POST', '/cart/add.js');
      //       xhr.open('POST', '/cart/add.js?sections=cart-drawer,cart-icon-bubble');
      //       xhr.send(formData);
      //     });

      //     const result = await responsePromise;

      //     // --- DA QUI IN POI: RIPRISTINI IL CODICE ORIGINALE DEL TEMA ---

      //     if (result.status) {
      //       // Gestione errori
      //       publish(PUB_SUB_EVENTS.cartError, {
      //         source: 'product-form',
      //         productVariantId: this.getMainProductVariantId(),
      //         errors: result.errors || result.description,
      //         message: result.message,
      //       });

      //       this.handleErrorMessage(result.description);

      //       const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
      //       if (soldOutMessage) {
      //         this.submitButton.setAttribute('aria-disabled', true);
      //         this.submitButtonText.classList.add('hidden');
      //         soldOutMessage.classList.remove('hidden');
      //       }
      //       this.error = true;
      //       return;
      //     } else if (!this.cart) {
      //       // Se non c'è cart drawer/notification, reindirizza al carrello
      //       window.location = window.routes.cart_url;
      //       return;
      //     }

      //     console.log('Prodotto principale aggiunto con successo');

      //     if (!this.error) {
      //       publish(PUB_SUB_EVENTS.cartUpdate, {
      //         source: 'product-form',
      //         productVariantId: this.getMainProductVariantId(),
      //         cartData: result,
      //       });
      //     }

      //     this.error = false;

      //     const quickAddModal = this.closest('quick-add-modal');
      //     if (quickAddModal) {
      //       document.body.addEventListener(
      //         'modalClosed',
      //         () => {
      //           setTimeout(() => {
      //             this.cart.renderContents(result);
      //           });
      //         },
      //         { once: true }
      //       );
      //       quickAddModal.hide(true);
      //     } else {
      //       this.cart.renderContents(result);
      //     }

      //     // Reset del bottone
      //     buttonText.textContent = 'Aggiunto!';
      //     setTimeout(() => {
      //       buttonText.textContent = 'Aggiungi al carrello';
      //     }, 800);

      //   } catch (error) {
      //     console.error('Errore durante l\'aggiunta del prodotto principale:', error);
      //     this.handleErrorMessage('Si è verificato un errore durante l\'aggiunta al carrello.');
      //     throw error;
      //   }
      // }


      // async addMainProduct() {
      //   try {
      //     const form = this.querySelector('form[data-type="add-to-cart-form"]');
      //     const formData = new FormData(form);
      //     const xhr = new XMLHttpRequest();
      //     const buttonText = this.submitButton.querySelector('.icona_testo_atc');
      //     const spinner = this.querySelector('.loading__spinner');

      //     // Mostra iniziale
      //     let lastProgress = 0;
      //     let targetProgress = 0;
      //     buttonText.textContent = 'Caricamento 0%';
      //     // spinner.classList.remove('hidden');

      //     const responsePromise = new Promise((resolve, reject) => {
      //       // Aggiornamento reale
      //       xhr.upload.onprogress = (e) => {
      //         if (e.lengthComputable) {
      //           targetProgress = Math.round((e.loaded / e.total) * 100);
      //         }
      //       };

      //       // Aggiornamento fluido ogni 100ms
      //       const interval = setInterval(() => {
      //         if (lastProgress < targetProgress) {
      //           lastProgress += Math.min(2, targetProgress - lastProgress); // avanza max 2% ogni tick
      //           buttonText.textContent = `Caricamento ${lastProgress}%`;
      //         }
      //         if (lastProgress >= 100) clearInterval(interval);
      //       }, 100);

      //       xhr.onload = () => {
      //         clearInterval(interval);
      //         if (xhr.status >= 200 && xhr.status < 300) {
      //           try {
      //             const result = JSON.parse(xhr.responseText);
      //             resolve(result);
      //           } catch (err) {
      //             console.error('Errore parsing JSON:', xhr.responseText);
      //             reject(err);
      //           }
      //         } else {
      //           reject(xhr.statusText);
      //         }
      //       };

      //       xhr.onerror = () => reject('Errore di rete');

      //       xhr.open('POST', '/cart/add.js?sections=cart-drawer,cart-icon-bubble');
      //       xhr.send(formData);
      //     });

      //     const result = await responsePromise;

      //     // --- DA QUI IN POI: RIPRISTINO LOGICA ORIGINALE TEMA ---

      //     if (result.status) {
      //       publish(PUB_SUB_EVENTS.cartError, {
      //         source: 'product-form',
      //         productVariantId: this.getMainProductVariantId(),
      //         errors: result.errors || result.description,
      //         message: result.message,
      //       });

      //       this.handleErrorMessage(result.description);
      //       this.submitButton.removeAttribute('aria-disabled');

      //       const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
      //       if (soldOutMessage) {
      //         this.submitButton.setAttribute('aria-disabled', true);
      //         this.submitButtonText.classList.add('hidden');
      //         // this.submitButton.classList.remove('loading');
      //         soldOutMessage.classList.remove('hidden');
      //       }
      //       this.error = true;
      //       return;
      //     } else if (!this.cart) {
      //       window.location = window.routes.cart_url;
      //       return;
      //     }

      //     console.log('Prodotto principale aggiunto con successo');

      //     if (!this.error) {
      //       publish(PUB_SUB_EVENTS.cartUpdate, {
      //         source: 'product-form',
      //         productVariantId: this.getMainProductVariantId(),
      //         cartData: result,
      //       });
      //     }

      //     this.error = false;

      //     const quickAddModal = this.closest('quick-add-modal');
      //     if (quickAddModal) {
      //       document.body.addEventListener(
      //         'modalClosed',
      //         () => {
      //           setTimeout(() => {
      //             this.cart.renderContents(result);
      //           });
      //         },
      //         { once: true }
      //       );
      //       quickAddModal.hide(true);
      //     } else {
      //       this.cart.renderContents(result);
      //     }

      //     // Reset bottone
      //     buttonText.textContent = 'Aggiunto!';
      //     setTimeout(() => {
      //       buttonText.textContent = 'Aggiungi al carrello';
      //     }, 800);

      //   } catch (error) {
      //     console.error('Errore durante l\'aggiunta del prodotto principale:', error);
      //     this.handleErrorMessage('Si è verificato un errore durante l\'aggiunta al carrello.');
      //     throw error;
      //   }
      // }



      getMainProductConfig() {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        // Rimuovi tutti gli input items[][] per evitare conflitti
        const keysToDelete = [];
        for (let [key, value] of formData.entries()) {
          if (key.startsWith('items[')) {
            keysToDelete.push(key);
          }
        }
        keysToDelete.forEach(key => formData.delete(key));
        
        // Aggiungi le sezioni per il rendering del carrello se necessario
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;
        return config;
      }

      getUpsellProductConfig(upsellVariantId) {
        const upsellFormData = new FormData();
        upsellFormData.append('id', upsellVariantId);
        upsellFormData.append('quantity', 1);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = upsellFormData;

        return config;
      }

      getUpsellVariantId() {
        // Ottieni l'ID dell'upsell dinamicamente ogni volta che viene chiamato
        // questo permette allo snippet liquid di aggiungere l'attributo prima del submit
        return this.dataset.upsellVariantId;
      }

      getMainProductVariantId() {
        const formData = new FormData(this.form);
        return formData.get('id');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
        } else {
          this.submitButton.removeAttribute('disabled');
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}